<template lang="pug">
div
  .m-2
    .columns.align-center.my-2.p-1.bordered(v-for="(value, key) in model")
      .column.col-auto {{ key }}:
      .column {{ value }}
      .column.col-auto
        a.btn.btn-link.btn-sm.text-warning.c-hand(@click="onEdit(key, value)")
          i.fas.fa-edit
        a.btn.btn-link.btn-sm.text-error.c-hand(@click="onRemove(key)")
          i.fas.fa-trash
  form(@submit.prevent="onSubmit")
    .columns
      .column.col-4
        input.input-sm.form-input(placeholder="Chave" v-model="$v.form.key.$model")
      .column
        input.input-sm.form-input(placeholder="Valor" v-model="$v.form.value.$model")
      .column.col-auto
        button.btn.btn-sm.btn-action.btn-primary(:disabled="$v.form.$invalid")
          i.fas.fa-check
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      form: {
        key: '',
        value: '',
      },
    }
  },
  props: ['value'],
  computed: {
    model() {
      return this.value || {}
    },
  },
  validations: {
    form: {
      key: { required },
      value: { required },
    },
  },
  methods: {
    onSubmit() {
      const { key, value } = this.form
      this.$emit('input', { ...this.model, [key]: value })
      this.form = { key: '', value: '' }
    },
    onRemove(key) {
      const keys = Object.keys(this.model).filter(k => k !== key)
      const newValue = keys.reduce((acc, key) => {
        acc[key] = this.model[key]
        return acc
      }, {})
      this.$emit('input', newValue)
    },
    onEdit(key, value) {
      this.form = { key, value }
    },
  },
}
</script>

<style lang="stylus" scoped>
.bordered
  border 1px solid #eee
  border-radius 5px
</style>
